import { styled  } from "@mui/material/styles";

export const ManageBookingMenuContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));